import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="w-full bg-white border-b border-gray-200" data-id="element-277" data-mp="2ink4ydk2sdl3">
      <div className="max-w-7xl mx-auto px-5 md:px-12 h-14 md:h-16 flex justify-between items-center" data-id="element-278" data-mp="2nlbtcxlihhkj">
        <div className="flex items-center" data-id="element-279" data-mp="2rlmbt9qhq0ga">
          <Link to="/home" className="no-underline" data-id="element-280" data-mp="2wl8o9gyhvco1">
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo Logo" className="h-7 md:h-8" data-id="element-281" data-mp="2wjntprc6jtq6" />
          </Link>
        </div>
        <nav className="hidden md:flex space-x-8" data-id="element-282" data-mp="36cwan3g723in">
          <Link to="/how-it-works" className="text-[#111111] no-underline hover:text-[#631bb7] transition-colors font-medium text-sm" data-id="element-283" data-mp="3bb64naq6my2o">
            How It Works
          </Link>
          <Link to="/resources" className="text-[#111111] no-underline hover:text-[#631bb7] transition-colors font-medium text-sm" data-id="element-284" data-mp="2wlm89d2q82jd">
            Guides
          </Link>
          <Link to="/pricing" className="text-[#111111] no-underline hover:text-[#631bb7] transition-colors font-medium text-sm" data-id="element-285" data-mp="2mn6sg695gfp6">
            Pricing
          </Link>
          <Link to="/about-us" className="text-[#111111] no-underline hover:text-[#631bb7] transition-colors font-medium text-sm" data-id="element-286" data-mp="3faswtgq7bod3">
            About Us
          </Link>
        </nav>
        <div className="hidden md:flex items-center space-x-4" data-id="element-287" data-mp="35jg3slso2s5h">
          <a href="/login" className="text-[#111111] no-underline hover:text-[#631bb7] font-medium text-sm transition-colors" data-id="element-288" data-mp="30lehlrzy2cps">
            Log in
          </a>
          <Link to="/onboarding" className="bg-[#1a0647] text-white px-5 py-2.5 rounded-md font-medium text-sm no-underline hover:bg-[#2a0a6e] transition-colors" data-id="element-289" data-mp="3ta29w7j422cu">
            Get Started
          </Link>
        </div>
        <div className="md:hidden flex items-center space-x-2" data-id="element-290" data-mp="1weh4ils4io0p">
          <a href="/login" className="text-[#111111] bg-gray-100 px-4 py-2 rounded-md font-medium text-sm no-underline hover:bg-gray-200 transition-colors" data-id="element-291" data-mp="1hn8jyr32vsuf">
            Log in
          </a>
          <button onClick={toggleMenu} className="text-[#111111] focus:outline-none p-2 min-h-[44px] min-w-[44px] flex items-center justify-center" aria-label="Toggle menu" data-id="element-292" data-mp="18p69lkxgfnuh">
            {isMenuOpen ? <XIcon size={24} data-id="element-293" data-mp="13ngzq8lyxg7z" /> : <MenuIcon size={24} data-id="element-294" data-mp="13p1x05zo3d9j" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden fixed inset-0 top-14 z-50 bg-white px-5 py-6 border-t border-gray-100" data-id="element-295" data-mp="2t3q9064cit71">
          <div className="flex flex-col space-y-4" data-id="element-296" data-mp="2xzxbtq1g3okr">
            <Link to="/how-it-works" className="text-[#111111] text-lg py-2 no-underline hover:text-[#631bb7] font-medium" onClick={toggleMenu} data-id="element-297" data-mp="mfptuac7twl3">
              How It Works
            </Link>
            <Link to="/resources" className="text-[#111111] text-lg py-2 no-underline hover:text-[#631bb7] font-medium" onClick={toggleMenu} data-id="element-298" data-mp="w6kh9i177284">
              Guides
            </Link>
            <Link to="/pricing" className="text-[#111111] text-lg py-2 no-underline hover:text-[#631bb7] font-medium" onClick={toggleMenu} data-id="element-299" data-mp="106kw33s7lffp">
              Pricing
            </Link>
            <Link to="/about-us" className="text-[#111111] text-lg py-2 no-underline hover:text-[#631bb7] font-medium" onClick={toggleMenu} data-id="element-300" data-mp="1a4s9jcnahfcy">
              About Us
            </Link>
            <div className="pt-6 mt-2 border-t border-gray-100" data-id="element-301" data-mp="22yno3tszf9hz">
              <Link to="/onboarding" className="bg-[#1a0647] text-white text-center py-3.5 rounded-md font-medium no-underline hover:bg-[#2a0a6e] transition-colors block w-full" onClick={toggleMenu} data-id="element-302" data-mp="22y5lmffq7z1m">
                Get Started
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}